import { Injectable } from '@angular/core';
import { HttpRequest, HttpEvent } from '@angular/common/http';
import { Subject } from 'rxjs';
import { CommonService } from './common.service';

@Injectable({
  providedIn: 'root',
})
export class APIHandlerService {
  private pendingRequests = new Map<HttpRequest<any>, Subject<void>>();

  constructor() {}

  addRequest(request: HttpRequest<any>, cancelSubject: Subject<void>): void {
    this.pendingRequests.set(request, cancelSubject);
  }

  // Remove a pending request
  removeRequest(request: HttpRequest<any>): void {
    const cancelSubject = this.pendingRequests.get(request);
    if (cancelSubject) {
      cancelSubject.next(); // Notify the interceptor to cancel the request
      this.pendingRequests.delete(request);
    }
  }

  // Clear all pending requests
  clearPendingRequests(): void {
    this.pendingRequests.forEach((cancelSubject) => cancelSubject.next());
    this.pendingRequests.clear();
  }
}
